import { IActiveChannel } from '@x/ecommerce-shop/app/channel/state/channel.state';

export class ChannelFetchAll {
  static readonly type = '[Channel] Fetch all';
}

export class ChannelFetchActive {
  static readonly type = '[Channel] Fetch active';
  constructor(public activeChannelCode: string) {}
}

export class ChannelSetActive {
  static readonly type = '[Channel] Set active';
  constructor(public activeChannel: IActiveChannel) {}
}

export class ChannelFetchAds {
  static readonly type = '[Channel] Fetch ads';
  constructor(public activeChannelCode: string) {}
}

export class ChannelFetchContent {
  static readonly type = '[Channel] Fetch content';
  constructor(public contentRef: string) {}
}

export class ChannelResetActiveChannelState {
  static readonly type = '[Channel] Reset active channel state';
}
